import { ContentSidePadding } from "components/ContentSidePadding";
import { ClassicChampionProfile } from "@ugg/shared/components/Champions/pages/Classic/ClassicChampionProfile";
import { RampLeftRail, RampRightRail } from "components/Ads/RampRails";
import { RampInContentContainer } from "@ugg/shared/components/Ads/RampInContent";
import { NamedAdUnits } from "@outplayed/ramp";
import { MediaQuery } from "@outplayed/responsive";
import { useAdFree } from "lib/hooks/use-ad-free";
import AppDownloadButton from "components/Buttons/AppDownloadButton";

// Web shell for the League Classic champion detail page. The ad-rail + center
// width structure intentionally mirrors the main champion Build page shell
// (components/Champions/ChampionProfile.tsx → RailAdsContainer) so switching
// between a champion's normal build and its Classic build is not jarring: same
// side rails, same 1014px centered content column (the width itself lives in
// the shared ClassicChampionProfile, matching the main page's inner div).
//
// The foot ad is passed in as the shared component's `bottomAd` slot so it
// renders under every Classic module (matching the normal build page), while
// the ad-free gating stays in the web layer where useAdFree lives.
export function ClassicChampionProfilePage() {
  const isAdFree = useAdFree();

  const bottomAd = !isAdFree && (
    // No mt here — the shared component's flex gap already spaces this module;
    // a margin would double the gap above the ad.
    <MediaQuery min="DESKTOP_MEDIUM" max="DESKTOP_LARGE" renderNullOnFail>
      <RampInContentContainer
        id="ugg-classic-builds-leaderboard"
        showAdLabel
        showPlusLink
        ignoreSkinAd
        type={NamedAdUnits.StandardIabFoot1}
        unitId="pw-builds-foot1"
        slotClassName="flex items-center justify-center w-full min-h-[90px] max-h-[250px] overflow-hidden"
      />
    </MediaQuery>
  );

  return (
    <div className="flex justify-center mx-auto w-full max-md:w-full">
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 mr-[-12px]">
          <RampLeftRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
      <ContentSidePadding className="max-md:w-full">
        <ClassicChampionProfile
          bottomAd={bottomAd}
          autoImportButton={
            <AppDownloadButton
              className="flex !min-h-[34px] !h-[34px] rounded-[3px] !px-[12px] !py-[8px] text-center max-md:hidden"
              url="/app?utm_source=uggclassicbuild"
              label="Download App"
              icon="cloud"
            />
          }
        />
      </ContentSidePadding>
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 ml-[-12px]">
          <RampRightRail className="sticky top-[calc(var(--masthead-height)+100px)] transition-[top]" />
        </div>
      </MediaQuery>
    </div>
  );
}
